import { ColumnElement, ColumnTitle } from '@atoms/columnElement';
import { LocalFormatSelector } from '@atoms/localFormatSelector/localFormatSelector';
import { SwitchV2 } from '@atoms/switch';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import type { AtomModel } from '@models/atom.model';
import type { Locale } from '@stratumn/studio-shared';
import type { PropsWithChildren } from 'react';

type Props = {
  selectedLocale: Locale;
  onLocaleChange: (locale: Locale) => void;

  tabRight: boolean;
  onTabRightChange: (tabRight: boolean) => void;

  atomId: AtomModel['id'];
};

export const NumberWidget = (props: PropsWithChildren<Props>) => (
  <>
    {props.children}

    <Column $width="200px">
      <ColumnTitle>Display options</ColumnTitle>

      <ColumnElement>
        <LocalFormatSelector
          id={props.atomId}
          onLocaleChange={props.onLocaleChange}
          selectedLocale={props.selectedLocale}
        />
      </ColumnElement>
      <ColumnElement>
        <SwitchV2
          checked={props.tabRight}
          id={`tab-right-${props.atomId}`}
          labelText="Place to right side"
          onCheckedChange={tabRight => props.onTabRightChange(tabRight)}
        />
      </ColumnElement>
    </Column>
  </>
);
